import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TASKALL } from "../../services/actions";
import { Container, Box, Typography, Button, Checkbox, TextField } from "@mui/material";
import XTable from "../extra/XTableAnother";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import VoiceMicButton from "../../components/VoiceMicButton";

export default function WorkAdminQueue() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const taskallState = useSelector((state) => state?.taskallState);
  const auth = useSelector((state) => state?.loginState?.auth);
  
  const [selectedTasks, setSelectedTasks] = useState([]);
  const [remarks, setRemarks] = useState("");

  const fetchTasksForReview = () => {
    // Assuming 'review' is the status for tasks awaiting approval
    dispatch({ type: `${TASKALL}_GET`, payload: `task/0/?filter_by={"status":"review"}` });
  };

  useEffect(() => {
    fetchTasksForReview();
  }, []);

  const handleSelect = (id) => {
    if (selectedTasks.includes(id)) {
      setSelectedTasks(selectedTasks.filter((t) => t !== id));
    } else {
      setSelectedTasks([...selectedTasks, id]);
    }
  };

  const handleAction = async (action) => {
    if (selectedTasks.length === 0) {
      Swal.fire("Warning", "Please select at least one task.", "warning");
      return;
    }
    
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}work-task/approve-reject/`,
        {
          task_ids: selectedTasks,
          action: action,
          remarks: remarks
        },
        {
          headers: { Authorization: `Bearer ${auth?.token}` }
        }
      );
      
      Swal.fire("Success", response.data.message, "success");
      setSelectedTasks([]);
      setRemarks("");
      fetchTasksForReview();
      
    } catch (error) {
      Swal.fire("Error", error.response?.data?.error || "An error occurred", "error");
    }
  };

  const tableHeadings = ["Select", "Task Name", "Project Name", "Company Name", "Status"];
  const tableRows = taskallState?.data?.results?.map((task) => ({
    id: task.id,
    select: (
      <Checkbox 
        checked={selectedTasks.includes(task.id)} 
        onChange={() => handleSelect(task.id)} 
      />
    ),
    task_name: task.task_name,
    project_name: task.project_name,
    company_name: task.company_name,
    status: task.status,
  })) || [];

  return (
    <Container maxWidth="false" className="py-3">
      <Box className="card-bg" sx={{ my: 2, py: 2, px: 2, borderRadius: 1 }}>
        <Typography variant="h6" fontWeight="bold">Work Admin Approval Queue</Typography>
      </Box>

      <Box sx={{ mb: 2, display: "flex", gap: 2, alignItems: "center" }}>
        <TextField 
          label="Remarks (Optional)" 
          variant="outlined" 
          size="small" 
          value={remarks} 
          onChange={(e) => setRemarks(e.target.value)} 
          InputProps={{
            endAdornment: (
              <VoiceMicButton
                initialText={remarks}
                onTranscript={(text) => setRemarks(text)}
              />
            )
          }}
          sx={{ flexGrow: 1, maxWidth: 400 }}
        />
        <Button variant="contained" color="success" onClick={() => handleAction('approve')}>
          Approve Selected
        </Button>
        <Button variant="contained" color="error" onClick={() => handleAction('reject')}>
          Reject Selected
        </Button>
      </Box>

      <XTable
        head={tableHeadings}
        rows={tableRows}
        onEdit={(row) => {
          navigate("/more-info/", { state: { data: row } });
        }}
      />
    </Container>
  );
}
